import styled from 'styled-components';

export const StyledTitleText = styled.h4`
  color: ${({ theme }) => theme.palette.primary.dark};
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
  font-weight: 500;
  letter-spacing: 0;
  line-height: ${({ theme }) => theme.typography.body1.lineHeight};
  margin: 0 0 ${({ theme }) => theme.spacing(0.5)};
`;

export const StyledRequiredMark = styled.span`
  color: ${({ theme }) => theme.palette.error.main};
`;

export const StyledBoldPath = styled.span`
  color: ${({ theme }) => theme.palette.common.black};
`;

export const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
  margin-top: ${({ theme }) => theme.spacing(3)};
`;

export const StyledNewPath = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: ${({ theme }) => theme.typography.subtitle1.fontSize};
  font-weight: 400;
  margin: 0;
`;
